export default {
    read_all: 'Read All Reviews',
}
